import React, { useState } from "react";
import { Box, Link } from "@mui/material";
import RKTextField from "../RKTextField/RKTextField";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";

interface Props {
  title: string;
  value: any;
  attrName: any;
  value_update: Function;
  warn_status: boolean;
  class_name: string;
  error_messg?: string;
}

const RKTextFieldDisable: React.FC<Props> = ({
  title,
  value,
  value_update,
  attrName,
  warn_status,
  class_name,
  error_messg,
}) => {
  const [disbaleToggle, setDisableToggle] = useState<boolean>(false);

  const updateMasterState = (attrName: any, value: any) => {
    value_update(attrName, value);
  };

  return (
    <Box className="individualEdit">
      {disbaleToggle === false ? (
        <div className="staticField">
          <label>{title}</label>
          <p>{value}</p>
        </div>
      ) : (
        <RKTextField
          class_name="inputField"
          title={title}
          value={value}
          attrName={attrName}
          value_update={updateMasterState}
          warn_status={false}
        />
      )}
      <Link
        className={disbaleToggle === true ? "editUpdate visible" : "editUpdate"}
        onClick={() => {
          setDisableToggle(!disbaleToggle);
        }}
      >
        {disbaleToggle === false ? <EditIcon /> : <CheckIcon />}
      </Link>
    </Box>
  );
};

export default RKTextFieldDisable;
